export default __webpack_public_path__ + "static/media/ico_error.1e95f681.svg";